import React from 'react'

import { HiOutlineCheck } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

interface TextOption {
  text: string
  selected: boolean
  className?: string
  innerClassName?: string
  children?: React.ReactNode
  style?: Record<string, any>
}

const TextOption: React.FC<TextOption> = ({
  text,
  selected,
  children,
  className = '',
  innerClassName = '',
  style,
}) => {
  return (
    <div
      className={twMerge('flex justify-between w-full px-1', className)}
      style={style}
    >
      <div
        className={twMerge('flex items-center w-11/12 gap-x-2', innerClassName)}
      >
        <span
          className={twMerge(
            'block truncate select-none',
            selected ? 'font-medium' : 'font-normal',
          )}
        >
          {text}
        </span>
        {children}
      </div>
      <div
        className={twMerge('flex items-center', selected ? '' : 'invisible')}
      >
        <HiOutlineCheck
          className="h-4 w-4 text-primary-600 dark:text-primary-300"
          aria-hidden="true"
        />
      </div>
    </div>
  )
}

export default TextOption
